import * as React from 'react';
import { useDragLayer, useDrop, DragObjectWithType, DropTargetMonitor } from 'react-dnd';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { Layer, DropTarget } from './styles';
import { importDesktopFiles } from '../../../containers/ImportManager/actions';
import { DndItemTypes } from '../../../typings/dnd';

interface FilesDndUploaderProps {
	dispatch: Dispatch<StoreState>;
}

const FilesDndUploader = ({ dispatch }: FilesDndUploaderProps) => {
	const {
		itemType,
		isDragging,
	} = useDragLayer(monitor => ({
		itemType: monitor.getItemType(),
		isDragging: monitor.isDragging(),
	}));

	const [, drop] = useDrop({
		accept: DndItemTypes.NATIVE_FILE,
		drop(item: DragObjectWithType, monitor: DropTargetMonitor) {
			const { files } = monitor.getItem();
			dispatch(importDesktopFiles(files));
		},
	});

	if (!isDragging || itemType !== DndItemTypes.NATIVE_FILE) {
		return null;
	}

	return (
		<Layer>
			<DropTarget ref={drop} />
		</Layer>
	);
};

export default FilesDndUploader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/FilesDndUploader/index.tsx